import IndustryChallengesI18n from "@/components/landing/shared/IndustryChallengesI18n";
import { MessageSquare, BookOpen, Users, Clock } from "lucide-react";
const HerausforderungenVerbaendeSection = () => <IndustryChallengesI18n translationPrefix="industryVerbaende" icons={[MessageSquare, BookOpen, Users, Clock]} />;
export default HerausforderungenVerbaendeSection;
